export const L10N = {
  ACTION_PRIVACY_POLICY: { id: 'core.action.privacy_policy' },

  LABEL_ALL_RIGHTS_RESERVED: { id: 'common.label.all_rights_reserved' },
};
